// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-container-component[data-v-4278c9bc]{background:var(--background-color-base);color:var(--text-disable)}.info-container-component.access[data-v-4278c9bc]{background:var(--access-bg);color:var(--access-text-color)}.info-container-component.access a[data-v-4278c9bc]{color:var(--access-text-color);-webkit-text-decoration:underline!important;text-decoration:underline!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
